var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 66H9a1 1 0 01-1-1V19a1 1 0 011-1h4v2h-3v44h38v2M72 54h-2V20h-3v-2h4a1 1 0 011 1v35",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 66a.997.997 0 01-.707-.293L35.586 62H13a1 1 0 01-1-1V15a1 1 0 011-1h23c.266 0 .52.105.707.293L40 17.586l3.293-3.293A.996.996 0 0144 14h23a1 1 0 011 1v39h-2V16H44.414l-3.707 3.707a.999.999 0 01-1.414 0L35.586 16H14v44h22c.266 0 .52.105.707.293L40 63.586l3.293-3.293A.996.996 0 0144 60h4v2h-3.586l-3.707 3.707A.997.997 0 0140 66",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 66h23a1 1 0 001-1V33h-2v31H48",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.414 62H67a1 1 0 001-1V29h-2v31H44M39 65h2V19h-2zM16 40h21v-2H16zM16 44h21v-2H16zM16 48h21v-2H16zM16 52h21v-2H16zM16 56h21v-2H16z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 34h17v-8H18v8zm18 2H17a1 1 0 01-1-1V25a1 1 0 011-1h19a1 1 0 011 1v10a1 1 0 01-1 1z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M43 22h21v-2H43zM43 26h21v-2H43zM43 30h21v-2H43zM43 46h21v-2H43zM43 50h21v-2H43zM43 54h21v-2H43z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M45 38h2v-2h-2zM49 38h9v-2h-9zM60 38h2v-2h-2z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M16 22h21v-2H16z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationBook;